<template>
  <nav class="case-navigation" aria-label="Project chapters">
    <a
      v-for="(chapter, index) in chapters"
      :key="chapter.id"
      :href="`#${$route.path}#${chapter.id}`"
      :aria-current="activeChapter === chapter.id ? 'location' : null"
      :class="[
        'case-nav-link',
        `chapter-${chapter.tone || 'overview'}`,
        { 'is-current': activeChapter === chapter.id },
      ]"
      @click.prevent="$emit('navigate', chapter.id, $event)"
    >
      <span class="case-nav-number" aria-hidden="true">{{
        String(index + startNumber).padStart(2, "0")
      }}</span>
      <span>{{ chapter.label }}</span>
      <span class="case-nav-track" aria-hidden="true"
        ><span
          :style="{
            transform: `scaleX(${activeChapter === chapter.id ? progress : 0})`,
          }"
        ></span
      ></span>
    </a>
  </nav>
</template>
<script>
export default {
  name: "ProjectChapterNav",
  props: {
    chapters: { type: Array, required: true },
    activeChapter: String,
    progress: Number,
    startNumber: { type: Number, default: 1 },
  },
  emits: ["navigate"],
  methods: {
    revealCurrent() {
      const current = this.$el.querySelector('[aria-current="location"]');
      if (!current) return;
      const rail = this.$el.getBoundingClientRect();
      const rect = current.getBoundingClientRect();
      if (rect.right > rail.right - 8)
        this.$el.scrollLeft += rect.right - rail.right + 16;
      else if (rect.left < rail.left + 8)
        this.$el.scrollLeft -= rail.left - rect.left + 16;
    },
  },
};
</script>
